import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      menu: 'Menu',
      reservations: 'Reservations',
      reviews: 'Reviews',
      location: 'Location',
      contact: 'Contact',
    },
    // Hero
    hero: {
      welcome: 'Welcome to',
      subtitle: 'Steakhouse, Italian & Carvery',
      since: 'Since 1991',
      cta: 'Reserve a Table',
      viewMenu: 'View Menu',
    },
    // About
    about: {
      overline: 'Our Story',
      title: 'Probably the Best Homemade Cuisine in Vilamoura',
      description: 'Since 1991, Rui\'s Restaurante has been serving the finest aged steaks, Italian cuisine and Sundays Carvery in the heart of Vilamoura. Our commitment to quality ingredients and traditional recipes has made us a beloved destination for locals and tourists alike.',
      rating: '4.5 Stars',
    },
    // Menu
    menu: {
      overline: 'Our Menu',
      title: 'Culinary Excellence',
      categories: {
        starters: 'Starters',
        steaks: 'Steaks',
        lamb: 'Lamb',
        fish: 'Fish',
        chicken: 'Chicken & Pork',
        pasta: 'Pastas',
        vegetarian: 'Vegetarian',
        burgers: 'Burgers',
        kids: 'Kids Menu',
        extras: 'Extras',
      },
    },
    // Reservations
    reservations: {
      overline: 'Book Your Table',
      title: 'Make a Reservation',
      description: 'Join us for an unforgettable dining experience. Reserve your table today.',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        date: 'Select Date',
        time: 'Select Time',
        guests: 'Number of Guests',
        guestLabel: 'guest',
        guestsLabel: 'guests',
        specialRequests: 'Special Requests',
        specialRequestsPlaceholder: 'Any dietary requirements or special occasions?',
        submit: 'Confirm Reservation',
        submitting: 'Booking...',
        selectTime: 'Choose a time',
        selectGuests: 'Choose guests',
      },
      success: {
        title: 'Reservation Confirmed!',
        message: 'Thank you for your reservation. We look forward to welcoming you.',
        details: 'Reservation Details',
      },
      errors: {
        closed: 'Restaurant is closed on Mondays',
        fullyBooked: 'This time slot is fully booked',
        generic: 'Something went wrong. Please try again.',
      },
      closed: {
        title: 'Online booking is currently unavailable',
        message: 'To reserve a table, please contact us directly by phone. We look forward to welcoming you.',
      },
      hours: {
        title: 'Opening Hours',
        monday: 'Monday: Closed',
        tuesday: 'Tuesday - Sunday: 6 - 11 PM',
      },
    },
    // Reviews
    reviews: {
      overline: 'What Our Guests Say',
      title: 'Customer Reviews',
    },
    // Awards
    awards: {
      overline: 'Recognition',
      title: 'Awarded Excellent Steaks 2026',
      description: 'We are honoured to be recognised by Restaurant Guru with the Excellent Steaks 2026 award. A heartfelt thank you to every guest whose support made this possible.',
      badge: 'Restaurant Guru · 2026',
      viewOn: 'View our page on',
    },
    // Location
    location: {
      overline: 'Find Us',
      title: 'Visit Our Restaurant',
      address: 'R. do Clube Náutico 4-5, 8125-442 Quarteira',
      callUs: 'Call Us',
      directions: 'Get Directions',
    },
    // Footer
    footer: {
      rights: 'All rights reserved.',
      accessibility: 'Accessibility',
      wheelchairEntrance: 'Wheelchair-accessible entrance',
      wheelchairSeating: 'Wheelchair-accessible seating',
      services: 'Services',
      outdoorSeating: 'Outdoor seating',
      delivery: 'Delivery',
      dineIn: 'Dine-in',
      payments: 'Payments',
      creditCards: 'Credit & Debit cards',
      nfc: 'NFC mobile payments',
      cash: 'Cash',
    },
    // Gallery
    gallery: {
      overline: 'Our Gallery',
      title: 'Moments at Rui\'s',
    },
    // Common
    common: {
      learnMore: 'Learn More',
      viewAll: 'View All',
    },
  },
  pt: {
    // Navigation
    nav: {
      home: 'Início',
      menu: 'Ementa',
      reservations: 'Reservas',
      reviews: 'Avaliações',
      location: 'Localização',
      contact: 'Contacto',
    },
    // Hero
    hero: {
      welcome: 'Bem-vindo ao',
      subtitle: 'Steakhouse, Italiano & Carvery',
      since: 'Desde 1991',
      cta: 'Reservar Mesa',
      viewMenu: 'Ver Ementa',
    },
    // About
    about: {
      overline: 'A Nossa História',
      title: 'Provavelmente a Melhor Cozinha Caseira em Vilamoura',
      description: 'Desde 1991, o Restaurante Rui\'s tem servido os melhores bifes maturados, cozinha italiana e Carvery aos Domingos no coração de Vilamoura. O nosso compromisso com ingredientes de qualidade e receitas tradicionais tornou-nos um destino querido por locais e turistas.',
      rating: '4.5 Estrelas',
    },
    // Menu
    menu: {
      overline: 'A Nossa Ementa',
      title: 'Excelência Culinária',
      categories: {
        starters: 'Entradas',
        steaks: 'Bifes',
        lamb: 'Borrego',
        fish: 'Peixe',
        chicken: 'Frango & Porco',
        pasta: 'Massas',
        vegetarian: 'Vegetariano',
        burgers: 'Hambúrgueres',
        kids: 'Menu Crianças',
        extras: 'Extras',
      },
    },
    // Reservations
    reservations: {
      overline: 'Reserve a Sua Mesa',
      title: 'Fazer Reserva',
      description: 'Junte-se a nós para uma experiência gastronómica inesquecível. Reserve a sua mesa hoje.',
      form: {
        name: 'Nome Completo',
        email: 'Endereço de Email',
        phone: 'Número de Telefone',
        date: 'Selecionar Data',
        time: 'Selecionar Hora',
        guests: 'Número de Pessoas',
        guestLabel: 'pessoa',
        guestsLabel: 'pessoas',
        specialRequests: 'Pedidos Especiais',
        specialRequestsPlaceholder: 'Requisitos dietéticos ou ocasiões especiais?',
        submit: 'Confirmar Reserva',
        submitting: 'A reservar...',
        selectTime: 'Escolha a hora',
        selectGuests: 'Escolha pessoas',
      },
      success: {
        title: 'Reserva Confirmada!',
        message: 'Obrigado pela sua reserva. Esperamos recebê-lo em breve.',
        details: 'Detalhes da Reserva',
      },
      errors: {
        closed: 'O restaurante está fechado às segundas-feiras',
        fullyBooked: 'Este horário está completamente reservado',
        generic: 'Algo correu mal. Por favor, tente novamente.',
      },
      closed: {
        title: 'As reservas online estão temporariamente indisponíveis',
        message: 'Para reservar uma mesa, por favor contacte-nos diretamente por telefone. Aguardamos a sua visita.',
      },
      hours: {
        title: 'Horário de Funcionamento',
        monday: 'Segunda: Fechado',
        tuesday: 'Terça - Domingo: 18h - 23h',
      },
    },
    // Reviews
    reviews: {
      overline: 'O Que Dizem os Nossos Clientes',
      title: 'Avaliações de Clientes',
    },
    // Awards
    awards: {
      overline: 'Reconhecimento',
      title: 'Distinguidos com Excelentes Carnes 2026',
      description: 'É uma honra sermos reconhecidos pelo Restaurant Guru com o prémio Excelentes Carnes 2026. Um sincero agradecimento a cada cliente que tornou esta distinção possível.',
      badge: 'Restaurant Guru · 2026',
      viewOn: 'Ver a nossa página no',
    },
    // Location
    location: {
      overline: 'Encontre-nos',
      title: 'Visite o Nosso Restaurante',
      address: 'R. do Clube Náutico 4-5, 8125-442 Quarteira',
      callUs: 'Ligue-nos',
      directions: 'Obter Direções',
    },
    // Footer
    footer: {
      rights: 'Todos os direitos reservados.',
      accessibility: 'Acessibilidade',
      wheelchairEntrance: 'Entrada acessível para cadeiras de rodas',
      wheelchairSeating: 'Lugares acessíveis para cadeiras de rodas',
      services: 'Serviços',
      outdoorSeating: 'Esplanada',
      delivery: 'Entrega',
      dineIn: 'Refeição no local',
      payments: 'Pagamentos',
      creditCards: 'Cartões de crédito e débito',
      nfc: 'Pagamentos móveis NFC',
      cash: 'Dinheiro',
    },
    // Gallery
    gallery: {
      overline: 'A Nossa Galeria',
      title: 'Momentos no Rui\'s',
    },
    // Common
    common: {
      learnMore: 'Saber Mais',
      viewAll: 'Ver Todos',
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'pt' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
